
import Vue from 'vue'
//sticky footer
// create an Observer instance
const resizeObserver = new ResizeObserver(() => {
  const footer = document.getElementById('footer')
  const bodyH = document.body.scrollHeight

  const screenH = window.innerHeight - 50
  if (footer)
    if (bodyH > screenH) {
      footer.style.position = 'relative'
    } else {
      footer.style.position = 'absolute'
    }
})

// start observing a DOM node
resizeObserver.observe(document.body)

export default Vue.extend({
  name: 'BaseFooter',
  data() {
    return {
      items: [{ html: 'info' }],
    }
  },
})
